import { render, staticRenderFns } from "./EditRule.vue?vue&type=template&id=a422a7b0"
import script from "./EditRule.vue?vue&type=script&lang=js"
export * from "./EditRule.vue?vue&type=script&lang=js"
import style0 from "./EditRule.vue?vue&type=style&index=0&id=a422a7b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports